import { SearchTerm } from './SearchTerm';

const ControllerSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "devName",
        translationKey: "name"
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        searchOnName: "devFixedAddr",
        translationKey: "fixedAddress"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        searchOnName: "devIpAddress",
        translationKey: "ipAddress"
    },
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "unitType.trnName",
        translationKey: "type"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
    {
        heading: "Preset",
        accessor: "preset",
        searchOnName: "profile.trnName",
        translationKey: "preset"
    },
];

export default ControllerSearch;
